export const generateChannelCIDKey = ({
  orgId,
  streamId,
  channelId,
  id = channelId,
} = {}) => {
  if (orgId && streamId && id) {
    return `${orgId}/${streamId}/${id}`;
  }

  return 'timeline';
};
